import React, { useEffect } from 'react';
import { Sounds } from '../../@resources/sounds';
import { AudioManager } from '../../platform/AudioManager';
import { useResolve } from '../Container';

export interface SoundEffectProps {
    name: keyof typeof Sounds;
    delay?: number;
}

export const SoundEffect = React.memo<SoundEffectProps>(({ name, delay }) => {
    const audio = useResolve(AudioManager);
    useEffect(() => {
        name = Sounds[name];
        if (delay) {
            const t = setTimeout(() => audio.play(name), delay);
            return () => clearTimeout(t);
        }
        else {
            audio.play(name);
        }
    }, [name, delay]);
    return null;
});
